import React, { useState, useEffect } from "react";
import { DataTableHeader, DataTableBody, DataTableFooter, DataTableSearch } from "./components";
import { Table } from "react-bootstrap";

const DataTable = ({
  columns,
  data = [],
  serverSide = false,
  totalRows,
  defaultPageSize = 50,
  onQueryChange,
  filterElement,
  actionElement,
  showSearch = true, // ✅ controlled via props
  rowClassName,
  className = '',
}) => {
  const [query, setQuery] = useState({
    page: 1,
    pageSize: defaultPageSize,
    search: "",
    sort: null,
  });
  const [processedData, setProcessedData] = useState(data);

  useEffect(() => {
    if (serverSide && onQueryChange) {
      onQueryChange(query);
    } else {
      let filtered = [...data];

      // 🔎 Search
      if (query.search) {
        filtered = filtered.filter((row) =>
          columns.some(
            (col) =>
              col.searchable &&
              String(resolveValue(row, col.accessor))
                .toLowerCase()
                .includes(query.search.toLowerCase())
          )
        );
      }

      // ↕ Sort
      if (query.sort) {
        const { columnId, direction } = query.sort;
        filtered.sort((a, b) => {
          const valA = resolveValue(a, columns.find((c) => c.id === columnId)?.accessor);
          const valB = resolveValue(b, columns.find((c) => c.id === columnId)?.accessor);
          if (valA < valB) return direction === "asc" ? -1 : 1;
          if (valA > valB) return direction === "asc" ? 1 : -1;
          return 0;
        });
      }

      // 📄 Pagination
      const start = (query.page - 1) * query.pageSize;
      setProcessedData(filtered.slice(start, start + query.pageSize));
    }
  }, [query, data, columns, serverSide, onQueryChange]);

  const total = serverSide ? totalRows : data.length;

  return (
    <div className={`datatable ${className ? ' ' + className : ''}`}> 
      {/* ✅ Conditionally show search box */}
      {showSearch && (
        <DataTableSearch query={query} setQuery={setQuery} filterElement={filterElement} actionElement={actionElement} />
      )}

      {/* Table */}
      <Table responsive>
        <DataTableHeader columns={columns} query={query} setQuery={setQuery} />
        <DataTableBody columns={columns} rows={processedData} rowClassName={rowClassName} />
      </Table>

      {/* Pagination */}
      <DataTableFooter total={total} query={query} setQuery={setQuery} />
    </div>
  );
};

export default DataTable;

function resolveValue(row, accessor) {
  if (!accessor) return null;
  return typeof accessor === "function"
    ? accessor(row)
    : accessor.split(".").reduce((acc, key) => acc?.[key], row);
}
